import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {TableComponent} from '../../../../components/table/table.component';

@Component({
  selector: 'app-authenticated-time-tracking-public-holidays-index',
  templateUrl: './index.component.html',
  imports: [TableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {

  public ngOnInit() {
    this.titleService.setTitle('authenticated.time_tracking.public_holidays.index.title');
  }
}
